var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{key:_vm.$route.path}),_c('n-alerts'),_c('vue-progress-bar'),_c('versioning-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }